import {element_exists} from "../functions";
import {popupCenterDual} from "../jquery-functions-library";

export var fnToggleBenefits = function () {
    var $element = '#btn-group-employment-type';

    if (!element_exists($element)) return false;

    let $hasFreeCarEl = $('input[name="employment[has_free_car]"]');
    let $dstToggle = $('input[name="employment[danmarks_statistik]"]');
    let $dstFormGroup = $('.danmarks_statistik-form-group');
    let $freeCarExtraEl = $('.free_car_extra-container');
    let $freeCarUploadsEl = $('.free_car_uploads-container');
    let $freeCarAttachmentsEl = $('.free_car_attachments-container');
    let $freeCarBtnRemoveEl = $('.btn-remove-attachment');
    let $freeCarBtnOpenEl = $('.btn-open-attachment');
    let $hasHealthInsuranceEl = $('input[name="employment[has_health_insurance]"]');
    let $hasLunchArrangementEl = $('input[name="employment[has_lunch_arrangement]"]');
    let $hasFixedAddOnsEl = $('input[name="employment[has_fixed_add_ons]"]');
    let $fixedAddOnsMonthlyEl = $('.fixed_add_ons_monthly-container');
    let $LunchArrangementMonthlyEl = $('.lunch_arrangement_monthly-container');
    let $hasPension = $('input[name="employment[has_pension]"]');
    let $pensionTab = $('.pension-tab');
    let $pensionFormGroup = $('#pension-tab')
    let $pensionSaveBtn = $('.btn-quick-submit-no-pension');
    let $nextBtnPension = $('.next-button');
    let hiddenClass = 'hidden';

    $hasFreeCarEl.off('change').on('change', function (e) {
        $hasFreeCarEl.is(':checked') ? $freeCarExtraEl.removeClass(hiddenClass) : $freeCarExtraEl.addClass(hiddenClass);
    });

    $freeCarBtnRemoveEl.off('click').on('click', function (e) {
        $freeCarUploadsEl.removeClass(hiddenClass);
        $freeCarAttachmentsEl.addClass(hiddenClass);
    });

    $freeCarBtnOpenEl.off('click').on('click', function (e) {
        const id = $(this).data('id');
        const url = `/employees/${id}/file`;
        popupCenterDual(url, $(this).data('name'), window.innerWidth / 2, window.innerHeight / 1.2);
    });


    $dstToggle.off('change').on('change', function (e) {
        if($dstToggle.is(':checked')) {
            $dstFormGroup.removeClass(hiddenClass)
        } else {
            $dstFormGroup.addClass(hiddenClass);
            $('#disco_codes').val(null);
        }
    });

    //Functionality to make dropdown for disco-codes searchable and styling to fit with the rest of the styling of the form.
    $(document).ready(function() {
        $('#disco_code').select2({ width: "100%"}).css('border', '1px solid black');
        $('.select2-selection').addClass('disco_code_selection_container');
        $('.select2-selection__arrow').addClass('disco_code_container_arrow');
        $('.disco_code_container_arrow').css('display', 'none');
        $('.disco_code_selection_container').css('border', 'none');
        $('#disco_code_label').css('display', 'block')
        $('#disco_code_label').css('padding-top', '7px')
        $('#disco_code_small').css('display', 'block')
        $('.custom-border').css('border-bottom', '1px solid rgba(0, 0, 0, 0.26');
        $('.custom-border').css('padding-bottom', '7px');
        $('#disco_code_group').css('padding-bottom', '7px')
        $('#select2-disco_code-container').css('padding', '0px');
        $('#select2-disco_code-container').css('color', 'rgba(0, 0, 0, 0.54)');
        $('#disco_code_small').css('color', 'rgba(0, 0, 0, 0.54)');
    });

    $hasLunchArrangementEl.off('change').on('change', function (e) {
        if($hasLunchArrangementEl.is(':checked')) {
            $LunchArrangementMonthlyEl.removeClass(hiddenClass)     
        } else {
            $LunchArrangementMonthlyEl.addClass(hiddenClass);
        }
    });

    $hasFixedAddOnsEl.off('change').on('change', function (e) {
        if($hasFixedAddOnsEl.is(':checked')) {
            $fixedAddOnsMonthlyEl.removeClass(hiddenClass)     
        } else {
            $fixedAddOnsMonthlyEl.addClass(hiddenClass);
        }
    });

    $hasPension.off().on('change', function (e) {
        if($hasPension.is(':checked')) {
            $pensionTab.removeClass(hiddenClass);
            $pensionFormGroup.removeClass(hiddenClass);
            $pensionSaveBtn.addClass(hiddenClass);
            $nextBtnPension.removeClass(hiddenClass);
        } else {
            $pensionTab.addClass(hiddenClass);
            $pensionFormGroup.addClass(hiddenClass);
            $pensionSaveBtn.removeClass(hiddenClass);
            $nextBtnPension.addClass(hiddenClass);
        }
    });
};
